import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { menuRoles } from './core/constants/roles';
import { permissaoRotaGuard } from './core/guards/permissao-rota.guard';

const routes: Routes = [
    {
        path: '',
        pathMatch: 'full',
        redirectTo: 'diaria-adicional/diaria'
    },
    {
        path: 'diaria-adicional/diaria',
        loadChildren: () =>
            import('./pages/diaria-adicional/diaria-adicional/diaria-adicional.module').then(
                (m) => m.DiariaAdicionalModule
            )
    },
    {
        path: 'diaria-adicional/terceiros',
        loadChildren: () =>
            import('./pages/diaria-adicional/terceiros/terceiros.module').then(
                (m) => m.TerceirosModule
            )
    },
    {
        path: 'diaria-adicional/valores',
        loadChildren: () =>
            import('./pages/diaria-adicional/valores-diaria/valores-diaria.module').then(
                (m) => m.ValoresDiariaModule
            )
    },
    {
        path: 'nao-autorizado',
        loadChildren: () =>
            import('./pages/sem-autorizacao/sem-autorizacao.module').then(
                (m) => m.SemAutorizacaoModule
            )
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule {}
